import React, { useContext, useState, useEffect } from "react";
import tw from "twin.macro";
import BackgroundImage from "gatsby-background-image";
import { getImage } from "gatsby-plugin-image";
import { convertToBgImage } from "gbimage-bridge";
import Fade from "react-reveal/Fade";
import { useWindowSize } from "../utils";
import { myContext } from "../context/Provider";
import { handleNavClick } from "../utils"

// commponent imports
import HeroTitle from "./hero/HeroTitle";
import { Button, Container, openChat } from "./auvelity-ui";
import Callout from "./callout";
import VideoOverlay from "./video-overlay"

import "../pages/index.css";

const Hero = ({ children, dataObj, variant, subpage=false, formSuccess=false, fullColor, env, bgImgData, spanish, main }) => {
  const [atTop, setAtTop] = useState(true)
  const [isHovered, setIsHovered] = useState(false)
  const heroImg = getImage(bgImgData);
  const bgImg = convertToBgImage(heroImg);
  const [isOverlayVisible, setOverlayVisible] = useState(false);
  const [videoId, setVideoId] = useState("");

  const context = useContext(myContext);

  const openVideo = (id) => {
    setVideoId(id);
    setOverlayVisible(true);
  };

  const HeroComponent = bgImgData && variant !== "hero-home" ? BackgroundImage : "section";

  useEffect(() => {
    const handleScroll = () => {
      setAtTop(window.scrollY < 300)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <>
      {(dataObj.fingerTabs) && (
        <ul className={[
            fullColor ? "finger-tabs full-color" : "finger-tabs",
            isHovered ? "expanded" : "",
            atTop ? "opened" : ""
          ].join(" ")}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <li className="nurse"><a onClick={() => openChat()} target="_blank">Talk to a Nurse Navigator</a></li>
          <li className="savings"><a href="/savings-card">Savings Card</a></li>
          <li className="patient-stories"><a href="/patient-stories">Hear patient stories</a></li>
        </ul>
      )}
      <HeroComponent
        css={[
          tw`bg-cover bg-top`,
          variant === "patient" && context.isMobile && `background-position: calc(50% + 1.25rem) 50%`,
          spanish &&
            tw`background-position[65% 0%]  before:(background-position[65% 0%]) after:(background-position[65% 0%]) xl:(background-position[65% 0%] before:(background-position[65% 0%]) after:(background-position[65% 0%]))`,
          subpage && tw`w-full`,
          variant === "faqs" && 'max-height: 210px;',
          variant === "hero-home" && `height: 600px;` && tw`bg-blue bg-contain lg:(bg-cover)`,
          variant === "howitmayhelp" && `min-height:400px`,
          variant === "connect-with-provider" && `min-height:390px`,
        ]}
        className={
          `${variant === "hero-home" ? `${dataObj.classInfo} hero-home-cover` : dataObj.classInfo || ""} ${formSuccess ? "form-success" : ""}`
        }
        {...bgImg}
      >
        <div
          className={`${formSuccess ? "form-success" : ""}`}
          css={[
            variant === "hero-home" ? tw`relative overflow-x[hidden]` : ""
          ]}
        >
          {variant === "hero-home" && (
            <>
              <video
                tw="hidden md:block w-full h-full object-cover"
                src="/videos/auvelity-commercial-desktop.mp4"
                autoPlay
                muted
                playsInline={true}
                className="hero-video"
                poster={bgImgData.bgdesktop}
              />
              <video
                tw="md:hidden w-full object-contain"
                src="/videos/auvelity-commercial-mobile.mp4"
                autoPlay
                muted
                playsInline={true}
                className="hero-video"
                poster={bgImgData.bgMobile}
              />
              <span className="hero-text">Actor portrayals.</span>
            </>
          )}
          {children ? (
            children
          ) : (
            <Container>
              <div
                css={[
                  tw`flex justify-between text-blue lg:(py-12 h-auto)`,
                  bgImgData && tw`py-12 h-72`,
                  variant === "resources" && tw`h-36 lg:pt-0`,
                  variant === "terms" && tw`lg:pb-0`,
                  variant === "taking-auvelity" && `bg-white`
                ]}
                className={variant === "patient" ? 'patient-wrap' : ''}
              >
                <div
                  css={[
                    tw`flex flex-col justify-start text-blue lg:(w-4/6 py-8)`,
                    variant === "patient" && tw`lg:min-height[unset]`,
                    variant === "special" || variant === "connect-with-a-provider"
                      ? tw`w-full justify-start pl-0 pt-8 pb-4 min-height[auto] lg:(min-height[60vh] pb-0 w-1/2)`
                      : variant === "resources"
                      ? tw`w-full justify-center pl-0 py-8 min-height[6rem] md:min-height[auto] lg:pb-4`
                      : tw`w-4/5 md:w-3/5`,
                    variant === "terms" &&
                      tw`pb-4 w-full justify-center pl-0 md:(w-3/4 pb-0 min-height[auto] )`,
                    env === "white" && tw`text-white`,
                    variant === "savings" &&
                      tw`w-full py-8 lg:(w-full min-h-[unset] pt-0)`,
                    variant === "connect-with-a-provider" && tw`lg:(min-h-[auto])`,
                    variant === "side-effects" && tw`w-full justify-start pl-0 pt-8 pb-4 pr-0 min-height[auto] lg:(pb-0 w-1/2)`,
                  ]}
                >
                  {dataObj.logo && (
                    <>
                      <div>
                        <img tw="w-full" src={dataObj.logo} alt={dataObj.logoAlt} />
                      </div>
                    </>
                  )}

                  <div css={[variant === "terms" && tw`pb-4 md:pb-0`, variant === "connect-with-provider" && tw`max-width[500px]`]}>
                    {dataObj.title && (
                      <HeroTitle
                        iconNames={dataObj.icon}
                        title={dataObj.title}
                        variant={variant}
                      />
                    )}
                    <h1
                      css={[
                        tw`text-2xl max-w-xl font-bold tracking-tight leading-tight lg:(text-[34px] mb-10)`,
                        variant === "terms" && tw`max-w-2xl`,
                        variant === "savings" && tw`max-w-full lg:mb-[30px]`,
                        subpage && tw`max-w-full mb-[10px] lg:(text-[36px]) sm:(text-[24px])`,
                        variant === "patient" && tw`sm:text-center md:(text-left)`,
                        variant === "side-effects" && tw`text-white`,
                        variant === "on-my-side" && tw`text-white max-width[180px] lg:(max-width[100%])`,
                        variant === "connect-with-provider" && tw`text-white max-width[200px] lg:(max-width[100%])`,
                        formSuccess && tw`hidden`,
                        'text-shadow: 0.5px 0.5px black'
                      ]}
                      className={main ? 'main-patients' : ''}
                    >
                      {dataObj.subtitle}
                    </h1>
                  </div>

                  {subpage && dataObj.patientName && (
                    <div tw="flex flex-col lg:(flex-row)" className="patient-navigation">
                      <div tw="w-full order-2 lg:order-1 lg:w-2/4" className="go-back">
                        <Button
                          arrow="reverse"
                          onClick={e => handleNavClick(e, "/patient-stories")}
                          styles={[tw`w-[240px] md:w-auto`]}
                        >
                          <span>Go back</span>
                        </Button>
                      </div>
                      <div tw="w-full order-1 lg:order-2 lg:w-2/4">
                        <Button
                          arrow="true"
                          onClick={() => openVideo(dataObj.url)}
                          styles={[tw`w-[250px] md:w-auto`]}
                        >
                          <>Watch {dataObj.patientName}'s story</>
                        </Button>
                      </div>
                    </div>
                  )}

                  {(dataObj.paragraph1 && variant === "savings" ) && (
                    <div className="saving-desktop" tw="text-base font-semibold  mb-[40px]">{dataObj.paragraph1}</div>
                  )}

                  {(dataObj.paragraph1 && variant === "workdifferetly" ) && (
                    <div className="workdifferetly-desktop" tw="text-base font-semibold  mb-[40px]" style={{ maxWidth: `550px`}}>{dataObj.paragraph1}</div>
                  )}

                  {(dataObj.paragraph1 && variant === "howitmayhelp" ) && (
                    <div className="howitmayhelp-desktop" tw="text-base font-semibold  mb-[20px]">{dataObj.paragraph1}</div>
                  )}

                  {(dataObj.paragraph1 && variant === "on-my-side" ) && (
                    <div className="on-my-side-desktop" tw="text-base text-white font-semibold  mb-[20px] max-width[460px]">{dataObj.paragraph1}</div>
                  )}

                  {dataObj.paragraph1 && context.isMobile && (
                    <>
                      <div
                        css={[
                          tw`text-lg font-semibold hidden lg:(max-width[29rem] mb-6 block tracking-tight)`,
                          variant === "savings" && tw`lg:max-w-full`,
                        ]}
                      >
                        {dataObj.paragraph1}
                      </div>
                    </>
                  )}

                  {dataObj.paragraph2 && (
                    <div tw="text-base hidden lg:(block max-width[26rem] mb-10 tracking-tight)">
                      {dataObj.paragraph2}
                    </div>
                  )}

                  {(dataObj.paragraph1 && variant === "patient" ) && (
                    <div tw="text-base font-semibold">{dataObj.paragraph1}</div>
                  )}

                  {(dataObj.paragraph1 && variant === "auvelityonmyside" || dataObj.paragraph1 && variant === "callalladvocates") && (
                    <div className="onmyside-desktop" tw="text-base font-semibold">{dataObj.paragraph1}</div>
                  )}

                  {dataObj.paragraph2 && variant === "patient" && <div tw="mt-8">{dataObj.paragraph2}</div>}

                  {dataObj.callout && !dataObj.callout.mobileOnly && (
                    <div tw="hidden lg:(max-width[28rem] mb-10 block)">
                      <Callout color={dataObj.callout.color}>
                        <div tw="font-semibold text-blue text-base">
                          {dataObj.callout.text}
                        </div>
                      </Callout>
                    </div>
                  )}
                  {dataObj.button && (
                    <div tw="hidden lg:(mb-8 block)">
                      <Button
                        arrow={dataObj.button.arrow}
                        env={dataObj.button.env}
                        size={dataObj.button.size}
                        variant={dataObj.button.variant}
                      >
                        {dataObj.button.text}
                      </Button>
                    </div>
                  )}

                  {dataObj.customLeft && (
                    <div
                      css={[
                        tw`hidden lg:(mb-8 block)`,
                        variant !== "connect-with-a-provider" &&
                          tw`lg:(max-width[29rem])`,
                        variant === "connect-with-a-provider" &&
                          tw`lg:(max-width[40rem])`,
                        variant === "special" && tw`lg:(mb-0 max-width[32rem])` &&
                        variant === "auvelityonmyside" && tw`max-width[100px] lg:(mb-0 max-width[32rem])`,
                        variant === "callalladvocates" && tw`lg:(mb-0 max-width[32rem])`,
                        variant === "taking-auvelity" && tw`lg:(mb-0 max-width[32rem])`,
                        variant === "connect-with-provider" && tw`lg:(mb-0 max-width[570px])`,
                        variant === "side-effects" && tw`text-white`
                      ]}
                    >
                      {dataObj.customLeft}
                    </div>
                  )}
                </div>

                {dataObj.customRight && (
                  <div tw="hidden lg:block">{dataObj.customRight}</div>
                )}
              </div>
            </Container>
          )}
          {dataObj.actorPortrayal && (
            <Container>
              <div className={`actor-portrayal ${dataObj.actorCustomMobile ? 'actor-custom' : ''} ${dataObj.radial ? 'radial' : ''}`}
                css={[
                  tw`text-right pt-2 pb-2 mr-5 text-xs text-center lg:(pb-20 mr-10 text-ms text-white text-right)`,
                  dataObj.actorPortrayal === "blue" &&
                    (dataObj.actorPortrayalMobile === "white"
                      ? tw`text-white md:(text-blue)`
                      : tw`text-blue`),
                  dataObj.actorPortrayal === "white" && tw`text-white text-right`,
                  dataObj.actorPortrayal === "black" &&
                    (dataObj.actorPortrayalMobile === "white"
                      ? tw`text-white md:(text-black)`
                      : tw`text-black`),
                  dataObj.customActor &&
                    `@media (max-width: 950px) { position: relative; top: ${dataObj.customActor}; }`,
                  (variant === "special" || variant === "auvelityonmyside" || variant === "callingalladvocates") &&
                    tw`relative top[30rem] md:(mr-32 text-ms -top-32) lg:pb-0`,
                  variant === "shortActorPortrayal" && tw`lg:(pt-20 pb-6)`,
                  variant === "howitmayhelp" && tw`mt-[50px] mr-[50px] lg:(mt-0 mr-0)`,
                  `text-shadow: 0 0 4px black;`,
                ]}
              >
                {spanish !== undefined
                  ? "Retrato del actor"
                  : "Actor portrayal."}
              </div>
            </Container>
          )}
          {dataObj.actorPortrayals && (
            <Container>
              <div className={`actor-portrayal ${dataObj.actorCustomMobile ? 'actor-custom' : ''}`}
                css={[
                  tw`text-right pt-2 pb-2 mr-5 text-xs text-center lg:(pb-20 mr-10 text-ms text-white text-right)`,
                  dataObj.actorPortrayal === "blue" &&
                    (dataObj.actorPortrayalMobile === "white"
                      ? tw`text-white md:(text-blue)`
                      : tw`text-blue`),
                  dataObj.actorPortrayal === "white" && tw`text-white`,
                  dataObj.actorPortrayal === "black" &&
                    (dataObj.actorPortrayalMobile === "white"
                      ? tw`text-white md:(text-black)`
                      : tw`text-black`),
                  dataObj.customActor &&
                    `@media (max-width: 950px) { position: relative; top: ${dataObj.customActor}; }`,
                  (variant === "special" || variant === "auvelityonmyside" || variant === "callingalladvocates") &&
                    tw`relative top[30rem] md:(mr-32 text-ms -top-32) lg:pb-0`,
                  variant === "shortActorPortrayal" && tw`lg:(pt-20 pb-6)`,
                  variant === "howitmayhelp" && tw`mt-[50px] mr-[50px] lg:(mt-0 mr-0)`,
                  `text-shadow: 0 0 4px black;`,
                ]}
              >
                {spanish !== undefined
                  ? "Retrato del actor"
                  : "Actor portrayals."}
              </div>
            </Container>
          )}
          {dataObj.actorCustom && !formSuccess && (
            <Container>
              <div
                className="actor-portrayal"
                css={[
                  tw`text-center hidden pt-2 pb-2 mr-5 text-xs lg:(text-right pb-20 mr-10 mb-0 pb-0 text-ms relative top[-85px]) text-blue lg:block`
                ]}
              >
                Danielle. Taking AUVELITY since 2023.
              </div>
            </Container>
          )}
        </div>

      </HeroComponent>
      {!children && (
        <>
          <div tw="lg:(hidden)">{dataObj.customRight}</div>
          {dataObj.actorCustom && !formSuccess && (
            <Container>
              <div
                className="actor-portrayal"
                css={[
                  tw`text-center pt-2 pb-2 mr-5 text-xs lg:(text-right pb-20 mr-10 mb-0 pb-0 text-ms hidden) text-blue`
                ]}
              >
                Danielle. Taking AUVELITY since 2023.
              </div>
            </Container>
          )}
          {dataObj.actorCustomMobile && (
            <Container>
              <div
                className="actor-portrayal"
                css={[
                  tw`text-center pt-2 pb-2 mr-5 mt-5 text-xs lg:(text-right pb-20 mr-10 text-ms hidden) text-blue`
                ]}
              >
                Actor portrayal.
              </div>
            </Container>
          )}
          {dataObj.actorCustomPull && (
            <Container>
              <div
                className="actor-portrayal custom-pull"
                css={[
                  tw`text-center text-white pt-2 pb-2 mr-5 mt-[-86px] relative text-xs lg:(text-right pb-20 mr-10 text-ms) text-blue`
                ]}
              >
                Actor portrayal.
              </div>
            </Container>
          )}
          <div
            css={[
              tw`text-blue block lg:(hidden)`,
              dataObj.paragraph1 && tw`bg-white py-14 lg:py-0`,
              (variant === "special" || variant === "connect-with-a-provider" || variant === "savings" || variant === "savings" || variant === "callalladvocates") &&
                tw`bg-transparent`,
              variant === "savings" && tw`pt-0 pb-[100px]`,
              variant === "patient" && tw`hidden`,
              variant === "howitmayhelp" && tw`pb-0`
            ]}
            className={formSuccess ? "form-success" : ""}
          >
            <Container>
              {dataObj.paragraph1 && variant !=="patient" && (
                <div tw="text-base font-semibold">{dataObj.paragraph1}</div>
              )}

              {dataObj.paragraph2 && variant !=="patient" && <div tw="mt-8">{dataObj.paragraph2}</div>}

              {dataObj.button && (
                <div tw="mx-auto pt-4">
                  <Button
                    arrow={dataObj.button.arrow}
                    env={dataObj.button.color}
                  >
                    {dataObj.button.text}
                  </Button>
                </div>
              )}
            </Container>
          </div>
          <div tw="rounded-br-regular rounded-tl-regular  bg-lightgrey">
            {dataObj.callout && (
              <div
                css={[
                  tw`block mb-20 lg:(hidden)`,
                  dataObj.callout.mobileBG === "gradient-lightgrey-blue" &&
                    tw`bg-gradient-grey-blue lg:(bg-none)`,
                  dataObj.callout.mobileBG === "gradient-grey" &&
                    tw`mb-0 lg:(bg-none mb-20)`,
                ]}
              >
                <Callout color={dataObj.callout.color} >
                  <div tw="font-semibold text-blue">{dataObj.callout.text}</div>
                </Callout>
              </div>
            )}
          </div>
          {dataObj.customLeft && (
            <div
              css={[
                dataObj.customLeftMobileBg === "lightgrey" && tw`bg-white py-14 lg:py-0`,
              ]}
            >
              <Container>
                <div tw="block lg:hidden">{dataObj.customLeft}</div>
              </Container>
            </div>
          )}
        </>
      )}
      {isOverlayVisible && (
        <VideoOverlay videoId={videoId} onClose={() => setOverlayVisible(false)} />
      )}
    </>
  );
};

export default Hero;
